import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import "./Translate.css";
import Select from "react-select";
import {
  TRANSLATE_KEY,
  TRANSLATE_LOCATION,
  TRANSLATE_ENDPOINT,
} from "../../../../env";

export interface TranslateProps {
  ChatConent: any;
  onMessageSend: any;
}

export const Translate: React.FC<TranslateProps> = ({
  ChatConent,
  onMessageSend,
}) => {
  const [languageOptions, setLanguageOptions] = useState<any[]>([]);
  const [language, setLanguage] = useState<string>(() => {
    return sessionStorage.getItem("selectedLanguage") || "";
  });
  const [includeEnglish, setIncludeEnglish] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    FetchLanguage();
  }, []);

  const FetchLanguage = async () => {
    try {
      const response = await fetch("/Languages_list");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const languages = data.map((lang: any) => ({
        label: lang.Languages,
        value: lang.Code,
      }));
      setLanguageOptions(languages);
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  useEffect(() => {
    setIncludeEnglish(includeEnglish);
  }, [includeEnglish]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setIncludeEnglish(isChecked);
    if (isChecked) {
      setLanguage("");
      sessionStorage.removeItem("selectedLanguage");
    }
  };

  const handleTranslate = async () => {
    setLoading(true);
    const key = TRANSLATE_KEY;
    const endpoint = TRANSLATE_ENDPOINT;
    const location = TRANSLATE_LOCATION;
    const toLanguage = includeEnglish ? "en" : language;

    try {
      const response = await axios({
        baseURL: endpoint,
        url: `/translate?api-version=3.0&from=en&to=${toLanguage}`,
        method: "post",
        headers: {
          "Ocp-Apim-Subscription-Key": key,
          "Ocp-Apim-Subscription-Region": location,
          "Content-type": "application/json",
          "X-ClientTraceId": uuidv4().toString(),
        },
        data: [
          {
            text: ChatConent,
          },
        ],
        responseType: "json",
      });

      const translatedText = response.data[0]?.translations[0]?.text || "";
      const translatedMessage = {
        text: translatedText,
        language: toLanguage,
        languageName:
          languageOptions.find((option) => option.value === toLanguage)
            ?.label || "",
      };
      onMessageSend(translatedMessage);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="Translate-modal-title"
      aria-describedby="Translate-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="modal-content-Translate">
        <button
         className="close-btn-translate "
          onClick={() => handleCloseModal()}
        >
          X
        </button>

        <p className="select-language">Select Language</p>
        <Select
          options={languageOptions}
          value={languageOptions.find((option) => option.value === language)}
          onChange={(selectedOption: any) => {
            setLanguage(selectedOption.value);
            sessionStorage.setItem("selectedLanguage", selectedOption.value);
          }}
          styles={{
            control: (styles) => ({
              ...styles,
              minWidth: "98%",
              marginBottom: "7px",
            }),
          }}
        />

        <label className="default-lang">
          <input
            type="checkbox"
            checked={includeEnglish}
            onChange={handleCheckboxChange}            
          />
          Default Language
        </label>

        {loading ? (
          <div className="Translate-loader"></div>
        ) : (
          <button className="translate-btn" onClick={handleTranslate}>
            Translate
          </button>
        )}
      </div>
    </Modal>
  );
};
